export const JURISDICTION_TABS = {
  STATES: 'states',
  FEDERAL: 'federal',
} as const

export type JurisdictionTab = (typeof JURISDICTION_TABS)[keyof typeof JURISDICTION_TABS]

/** Maximum number of states a user can select for comparison research */
export const MAX_SELECTED_STATES = 2

/** How long the "Maximum N states" warning stays visible before fading out (ms) */
export const WARNING_DISPLAY_MS = 1500
